/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Employer/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Employer({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/Employer"
  
}) {
let assignedInsuranceInsuranceSubscriptionEmployerNameValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.employer.name',
})
let constantData = '-'
let aggregateData = fromAggregate.any(assignedInsuranceInsuranceSubscriptionEmployerNameValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Employer.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="assigned_insurance.insurance_subscription.employer.name"
 data="'-'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}